import { Keyboard, Coins, Download, RotateCcw, Settings, LogOut, MessageSquareOff, Moon } from 'lucide-react';
import { logout, openShortcutsModal, openModal, setSidebarOpen, ui$, setColorTheme } from '../../store';
import { onboardingReplay$, openUsageModal } from '../../store/ui$';

export const hideFeedbackTemporarily = (t) => {
  if (!window.confirm(t('sidebar:footer.hideFeedbackConfirm'))) return false;
  const duration = 30 * 60 * 1000;
  localStorage.setItem('reedle-feedback-hidden-until', String(Date.now() + duration));
  document.body.classList.add('feedback-temporarily-hidden');
  setTimeout(() => {
    document.body.classList.remove('feedback-temporarily-hidden');
    localStorage.removeItem('reedle-feedback-hidden-until');
  }, duration);
  return true;
};

// The palette reuses the More menu's labels and destinations.
export const ACCOUNT_COMMANDS = [
  {
    id: 'cmd:toggle-theme', labelKey: 'sidebar:footer.theme', icon: Moon,
    keywords: ['theme', 'toggle', 'dark', 'light', '主题', '切换', '深色', '浅色'],
    action: () => setColorTheme(ui$.colorTheme.get() === 'dark' ? 'light' : 'dark'),
  },
  {
    id: 'cmd:shortcuts', labelKey: 'sidebar:footer.shortcuts', icon: Keyboard,
    keywords: ['shortcuts', 'keyboard', '快捷键'],
    action: () => openShortcutsModal(),
  },
  {
    id: 'cmd:usage', labelKey: 'sidebar:footer.usage', icon: Coins,
    keywords: ['usage', 'credits', 'balance', '用量', '额度', '余额'],
    action: () => openUsageModal(),
  },
  {
    id: 'cmd:extension', labelKey: 'sidebar:footer.extension', icon: Download,
    keywords: ['extension', 'browser', '扩展', '插件'],
    action: () => openModal('extension'),
  },
  {
    id: 'cmd:replay-tour', labelKey: 'sidebar:footer.replayTour', icon: RotateCcw,
    keywords: ['replay', 'tour', 'onboarding', '引导', '重播'],
    action: (navigate) => {
      onboardingReplay$.set(true);
      navigate('/');
      setSidebarOpen(false);
    },
  },
  {
    id: 'cmd:hide-feedback', labelKey: 'sidebar:footer.hideFeedback', icon: MessageSquareOff,
    keywords: ['hide', 'feedback', '隐藏', '反馈'],
    action: (_navigate, t) => hideFeedbackTemporarily(t),
  },
  {
    id: 'cmd:settings', labelKey: 'sidebar:footer.settings', icon: Settings,
    keywords: ['settings', 'preferences', '设置', '偏好'],
    action: (navigate) => {
      navigate('/settings');
      setSidebarOpen(false);
    },
  },
  {
    id: 'cmd:logout', labelKey: 'search:actions.logout',
    descriptionKey: 'search:actions.logoutDescription', icon: LogOut,
    keywords: ['logout', 'log out', 'sign out', 'exit', '退出', '登出', 'выход'],
    action: (_navigate, t) => {
      if (window.confirm(t('sidebar:confirm.logout'))) logout();
    },
  },
];
